export const ONBOARDING_ERROR_COPY = {
	PARTIAL_HAVING_ISSUES: 'Looks like we\'re having issues on our end. We\'re looking into it! Please reach out to ',
	PARTIAL_QUESTIONS: ' with any questions.',
	RESTART_ONBOARIDNG: 'Restart Onboarding',
	SOMETHING_WENT_WRONG: 'Something went wrong.'
};
